export default "__VITE_ASSET__BqzTDEUk__"